'use strict';

import assignIn from 'lodash/assignIn';
import isEmpty from 'lodash/isEmpty';
import isNull from 'lodash/isNull';
import isString from 'lodash/isString';
import isUndefined from 'lodash/isUndefined';
import DOMUtils from '@spothero/utils/dom';
import SHSignals from 'sh-signals';

let shModalOpening = false;

const closeClick = evt => {
    const target = evt.target;
    const modal = target.closest('.sh-modal');
    const remove = (!isEmpty(modal.getAttribute('data-remove-on-close'))) ? true : false;

    SHModal.close(modal, remove, () => {
        // dispatch signal in case you click the shim or close button
        // and need an event so you can react to it
        SHSignals.modalClosed.dispatch();
    });
};

const shimClick = () => {
    const closeBtn = DOMUtils.el('.sh-modal-open .close');

    closeBtn.click();
};

const modalClick = evt => {
    if (DOMUtils.hasClass(evt.target, 'sh-modal')) {
        shimClick();
    }
};

const escPressCheck = evt => {
    if (evt.keyCode === 27) {
        shimClick();
    }
};

const removeShim = shimEl => {
    window.transitionEnd(shimEl).bind(() => {
        window.transitionEnd(shimEl).unbind();

        shimEl.style.display = 'none';
        shimEl.parentNode.removeChild(shimEl);
    });

    DOMUtils.addClass(shimEl, 'visually-hidden');
};

const SHModal = {
    open(target, opts) {
        if (shModalOpening) {
            return null;
        }

        shModalOpening = true;

        const options = assignIn({}, opts);
        const inline = options.inline || false;
        const noShim = options.noShim || false;
        const noPageLock = options.noPageLock || false;
        const leaveOtherModalsOpen = (typeof options.leaveOtherModalsOpen === 'undefined') ? true : options.leaveOtherModalsOpen;
        const modal = (typeof target === 'undefined')
            ? this.getAttribute('data-target')
            : (isString(target))
                ? DOMUtils.el(target)
                : target;
        const prevModal = (inline) ? false : document.querySelector('.sh-modal-open');
        const shim = document.createElement('div');
        const body = DOMUtils.el('body');

        DOMUtils.addClass(shim, ['shim', 'visually-hidden']);

        window.transitionEnd(shim).bind(() => {
            window.transitionEnd(shim).unbind();

            DOMUtils.removeClass(modal, 'visually-hidden');
            DOMUtils.addClass(modal, 'sh-modal-open');
            modal.style.display = 'block';

            // (re-)attach events
            if (!inline) {
                this.attachEvents();
            }

            if (!noPageLock) {
                DOMUtils.addClass(body, 'modal-open');
            }

            DOMUtils.sendCustomEvent('sh-modal-opened', {modal});

            if (options.callback) {
                options.callback();
            }

            shModalOpening = false;
        });

        if (!noShim) {
            modal.parentNode.insertBefore(shim, modal);
        }

        setTimeout(() => {
            DOMUtils.removeClass(shim, 'visually-hidden');
        }, 200);

        // if previously opened modal
        if (prevModal && !leaveOtherModalsOpen) {
            // for inline modal pages lets just refresh the page to ensure state is correct
            if (DOMUtils.hasClass(body, 'inline')) {
                window.location.reload();
            } else {
                this.close(prevModal, true);
            }
        }
    },

    close(target, remove, callback) {
        const modal = target;
        const shim = modal.previousElementSibling;
        const body = DOMUtils.el('body');

        if (!modal) { return; }

        remove = (typeof remove !== 'undefined' && remove) ? true : false;

        window.transitionEnd(modal).bind(() => {
            window.transitionEnd(modal).unbind();

            modal.style.display = 'none';

            if (remove) {
                modal.parentNode.removeChild(modal);
            }

            if (!isUndefined(shim) && !isNull(shim)) {
                removeShim(shim);
            }

            DOMUtils.removeClass(body, 'modal-open');
        });

        DOMUtils.removeClass(modal, 'sh-modal-open');
        DOMUtils.addClass(modal, 'visually-hidden');
        DOMUtils.sendCustomEvent('sh-modal-closed');

        if (callback) {
            callback();
        }
    },

    watch() {
        DOMUtils.addEventListener({
            event: 'click',
            target: '[data-plugin="sh-modal"]',
            handler: evt => {
                evt.preventDefault();

                this.open(evt.currentTarget.getAttribute('data-target'));
            }
        });
    },

    attachEvents() {
        document.removeEventListener('click', closeClick);
        document.removeEventListener('click', shimClick);
        document.removeEventListener('click', modalClick);
        document.removeEventListener('keyup', escPressCheck);
        DOMUtils.addEventListener({
            event: 'click',
            target: '.sh-modal .close',
            handler: closeClick
        });
        DOMUtils.addEventListener({
            event: 'click',
            target: '.shim',
            handler: shimClick
        });
        DOMUtils.addEventListener({
            event: 'click',
            target: '.sh-modal',
            handler: modalClick
        });
        document.addEventListener('keyup', escPressCheck);
    }
};

module.exports = SHModal;



// WEBPACK FOOTER //
// ./frontend/src/js/utils/sh-modal.js